// path: src/App.tsx
import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import MainComponent from './components/MainComponent';
import GiltDivider from './components/GiltDivider';
import InAppBrowserNotice from './components/InAppBrowserNotice';
import './index.css';

const App: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Router>
      {/* only ever visible inside Instagram's / Facebook's in-app browser */}
      <InAppBrowserNotice />
      <div className="flex h-screen bg-gray-50 overflow-hidden">
        <Sidebar 
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <GiltDivider />
        <MainComponent 
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
      </div>
    </Router>
  );
};

export default App;
